export const DIABETES_SOURCE_MESSAGES = 70_163
export const DIABETES_SOURCE_DOCTORS = 6_023
export const DIABETES_MAIN_MESSAGES = 1_541
export const DIABETES_MAIN_DOCTORS = 627
export const DIABETES_MAIN_CHATS = 1_069
export const DIABETES_DIRECT_MESSAGES = 1_358
export const DIABETES_CONTEXTUAL_MESSAGES = 183
export const DIABETES_GSD_MESSAGES = 65
export const DIABETES_GSD_DOCTORS = 37
export const DIABETES_GSD_CHATS = 50
export const DIABETES_GSD_ENDOCRINOLOGIST_MESSAGES = 20
export const DIABETES_GSD_ENDOCRINOLOGIST_DOCTORS = 11
export const DIABETES_GSD_CANDIDATE_MESSAGES = 66

export const DIABETES_SPECIALTIES = [
  { id: 'therapist', label: 'Терапевты', messages: 488 },
  { id: 'other', label: 'Другие и редкие специальности', messages: 255 },
  { id: 'endocrinologist', label: 'Эндокринологи', messages: 202 },
  { id: 'cardiologist', label: 'Кардиологи', messages: 162 },
  {
    id: 'anesthesiology',
    label: 'Анестезиологи и реаниматологи',
    messages: 107,
  },
  { id: 'neurologist', label: 'Неврологи', messages: 89 },
  { id: 'generalPractitioner', label: 'Врачи общей практики', messages: 84 },
  { id: 'organizer', label: 'Организаторы здравоохранения', messages: 53 },
  { id: 'surgeon', label: 'Хирурги', messages: 49 },
  { id: 'pediatrician', label: 'Педиатры', messages: 27 },
  { id: 'oncologist', label: 'Онкологи', messages: 25 },
] as const

export const DIABETES_TOPICS = [
  { id: 'treatment', label: 'Лечение', messages: 634, share: '41,1%' },
  {
    id: 'diagnosis',
    label: 'Диагностика и определение типа диабета',
    messages: 373,
    share: '24,2%',
  },
  {
    id: 'labs',
    label: 'Анализы и исследования',
    messages: 366,
    share: '23,8%',
  },
  {
    id: 'glycemia',
    label: 'Гликемия, мониторинг и целевые значения',
    messages: 310,
    share: '20,1%',
  },
  { id: 'drugs', label: 'Препараты', messages: 307, share: '19,9%' },
  {
    id: 'complications',
    label: 'Хронические осложнения',
    messages: 244,
    share: '15,8%',
  },
] as const

export const DIABETES_UNRECOGNIZED_TOPIC_MESSAGES = 328

export const DIABETES_CONTEXTS = [
  {
    id: 'cardiovascular',
    label: 'Сердечно-сосудистая тема',
    messages: 294,
    share: '19,1%',
  },
  {
    id: 'renal',
    label: 'Почки и почечная функция',
    messages: 267,
    share: '17,3%',
  },
  {
    id: 'obesity',
    label: 'Ожирение и масса тела',
    messages: 131,
    share: '8,5%',
  },
  {
    id: 'perioperative',
    label: 'Периоперационная тема',
    messages: 103,
    share: '6,7%',
  },
] as const

export const DIABETES_NON_ENDOCRINOLOGY_SPECIALTY_IDS = [
  'therapist',
  'cardiologist',
  'anesthesiology',
  'neurologist',
  'generalPractitioner',
  'surgeon',
  'pediatrician',
  'oncologist',
] as const

export const DIABETES_CARDIOVASCULAR_TREATMENT_MESSAGES = 189
export const DIABETES_RENAL_DRUGS_MESSAGES = 98
export const DIABETES_HBA1C_DIAGNOSIS_MESSAGES = 82
export const DIABETES_PERIOPERATIVE_TREATMENT_MESSAGES = 69
export const DIABETES_METFORMIN_RENAL_MESSAGES = 42
export const DIABETES_INSULIN_CALCULATION_MESSAGES = 27

export const DIABETES_COMBINATIONS = [
  {
    id: 'cardiovascularTreatment',
    label: 'Сердечно-сосудистая тематика и лечение',
    messages: DIABETES_CARDIOVASCULAR_TREATMENT_MESSAGES,
  },
  {
    id: 'renalDrugs',
    label: 'Почечная тематика и препараты',
    messages: DIABETES_RENAL_DRUGS_MESSAGES,
  },
  {
    id: 'hba1cDiagnosis',
    label: 'HbA1c и диагностика',
    messages: DIABETES_HBA1C_DIAGNOSIS_MESSAGES,
  },
  {
    id: 'perioperativeTreatment',
    label: 'Периоперационная тематика и лечение',
    messages: DIABETES_PERIOPERATIVE_TREATMENT_MESSAGES,
  },
  {
    id: 'metforminRenal',
    label: 'Метформин и почечная тематика',
    messages: DIABETES_METFORMIN_RENAL_MESSAGES,
  },
  {
    id: 'insulinCalculation',
    label: 'Инсулин и расчет',
    messages: DIABETES_INSULIN_CALCULATION_MESSAGES,
  },
] as const

export const DIABETES_TYPES = [
  {
    id: 'unspecified',
    label: 'Тип не указан',
    messages: 841,
    share: '54,6%',
  },
  { id: 'type2', label: 'СД 2', messages: 606, share: '39,3%' },
  {
    id: 'type1',
    label: 'СД 1 и сравнения типов',
    messages: 94,
    share: '6,1%',
  },
] as const

export const DIABETES_GSD_TOPICS = [
  { id: 'treatment', label: 'Лечение и тактика', messages: 19 },
  {
    id: 'diagnosis',
    label: 'Диагностика и глюкозотолерантный тест',
    messages: 18,
  },
  { id: 'glycemia', label: 'Гликемия и контроль', messages: 15 },
  {
    id: 'postpartum',
    label: 'Послеродовый период и лактация',
    messages: 11,
  },
  { id: 'nutrition', label: 'Питание и образ жизни', messages: 10 },
  { id: 'gestationalAge', label: 'Срок беременности', messages: 10 },
] as const

export const sumDiabetesSpecialtyMessages = () =>
  DIABETES_SPECIALTIES.reduce((total, row) => total + row.messages, 0)

export const sumDiabetesTypeMessages = () =>
  DIABETES_TYPES.reduce((total, row) => total + row.messages, 0)

const nonEndocrinologySpecialtyIds = new Set<string>(
  DIABETES_NON_ENDOCRINOLOGY_SPECIALTY_IDS,
)

export const sumNonEndocrinologySpecialtyMessages = () =>
  DIABETES_SPECIALTIES.reduce(
    (total, row) =>
      nonEndocrinologySpecialtyIds.has(row.id) ? total + row.messages : total,
    0,
  )

export const DIABETES_NON_ENDOCRINOLOGY_MESSAGES =
  sumNonEndocrinologySpecialtyMessages()

export const DIABETES_NON_ENDOCRINOLOGY_SHARE =
  Math.round(
    (DIABETES_NON_ENDOCRINOLOGY_MESSAGES / DIABETES_MAIN_MESSAGES) * 1_000,
  ) / 10
